import React, {Fragment} from 'react';
import * as PropTypes from 'prop-types';
import {h1Styles, h5Styles, paddingTopStyles} from "./styles/ProductsSection.css";
import ProductCard from "./components/ProductCard";

const ProductsSection = (props) => {

  let apps = props.apps;

  let Products = () => {
    let products = [];
    if (apps) {
      apps.forEach((app, i) => {
        products.push(<ProductCard key={i} action={() => props.action(app)} app={app}/>);
      });
    }
    return products;
  };

  return (
    <Fragment>
      <div style={paddingTopStyles}>
        <div className={"container"}>
          <h1 className={"text-center"} style={h1Styles}>Let's get to work! <span aria-label="raised hands" role="img">🙌</span></h1>
          <h5 className={"text-center"} style={h5Styles}>{ "To get started, select your Lone Wolf product below" }</h5>
          <div style={paddingTopStyles}>
            <div className={"row justify-content-center"}>
              <Products/>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );

};

ProductsSection.propTypes = {
  apps: PropTypes.array.isRequired,
  action: PropTypes.func,
  isLimitedAccess: PropTypes.bool.isRequired
};

export default ProductsSection;
